// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__1tx6u","group":"List_group__3K365","title":"List_title__3ofkP"};